import { Phone, Mail, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";

export const Consultation = () => {
    const { t } = useTranslation();

    // 检测设备类型
    const isMobileDevice = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        return /android|iphone|ipad|ipod|windows phone/i.test(userAgent);
    };

    // 点击按钮时的行为
    const handleButtonClick = () => {
        if (isMobileDevice()) {
            // 移动设备：拨打电话
            window.location.href = "tel:+61 420 388 666";
        } else {
            // PC设备：发送邮件
            const email = "i.sunny.pan@gmail.com";
            const subject = encodeURIComponent("Consultation Request to Wanderland Australia");
            const body = encodeURIComponent("Hi,\n\nI would like to consult about..."); // 可根据需求修改默认邮件正文
            window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
        }
    };

    return (
        <section className="py-16 bg-[#1A2B3C] text-white">
            <div className="container mx-auto px-4">
                <h2 className="text-4xl font-bold mb-4">{t("consultation.consultation")}</h2>
                <p className="text-lg mb-8">{t("consultation.expert")}</p>
                <button
                    className="bg-[#C5A572] text-white px-8 py-3 rounded hover:bg-[#B39461] transition-colors"
                    onClick={handleButtonClick}
                >
                    {t("consultation.contact")}
                </button>
            </div>
        </section>
    );
};
